<template>
  <v-sheet
    color="white"
    elevation="1"
    class="pa-5"
  >
    <h3>Update Password</h3>

    <p>Update your password by entering your existing password and your new password below</p>

    <v-form ref="form" class="mx-2" v-model="valid" lazy-validation @keyup.native.enter="updatePassword">
      <v-text-field
        name="current"
        label="Current Password"
        v-model="passwords.current"
        :rules="currentPasswordRules"
        :append-icon="visibility.current ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="() => (visibility.current = !visibility.current)"
        :type="visibility.current ? 'password' : 'text'"
      ></v-text-field>
      <v-text-field
        id="password"
        name="password"
        label="Password"
        v-model="passwords.password"
        :rules="passwordRules"
        :append-icon="visibility.newPass ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="() => (visibility.newPass = !visibility.newPass)"
        :type="visibility.newPass ? 'password' : 'text'"
      ></v-text-field>
      <v-text-field
        id="password2"
        name="password2"
        label="Password"
        v-model="passwords.confirm"
        :rules="confirmPasswordRules.concat(passwordConfirmationRule)"
        :append-icon="visibility.confirmPass ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="() => (visibility.confirmPass = !visibility.confirmPass)"
        :type="visibility.confirmPass ? 'password' : 'text'"
      ></v-text-field>
    </v-form>
      <div>
        <v-btn class="center-button" outlined color="primary" type="submit" @click="updatePassword">Update Password</v-btn>
      </div>

  </v-sheet>
</template>

<script>
export default {
  name: "ManagePassword",
  data: () => ({
    valid: null,
    visibility: {
      current: String,
      newPass: String,
      confirmPass: String
    },
    passwords: {
      current: null,
      password: null,
      confirm: null
    },
    currentPasswordRules: [
      v => !!v || 'Password is required',
    ],
    passwordRules: [
      v => !!v || 'Password is required',
      v => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) || 'Password must contain at least lowercase letter, one number, a special character and one uppercase letter',
    ],
    confirmPasswordRules: [v => !!v || "Password is required"]
  }),
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.passwords.password === this.passwords.confirm || "Password must match";
    }
  },
  methods: {
    async updatePassword() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        const detail = "Please enter all fields required";
        await this.$store.dispatch("notification/triggerError", { detail: detail });
        return;
      }

      await this.$store.dispatch("loader/loaderInitiate", { title: "Updating account password" });

      const result = await this.$store.dispatch("auth/passwordUpdateApp", {
        pass: this.passwords.password,
        pass_confirmation: this.passwords.confirm,
        old_pass: this.passwords.current
      });

      await this.$store.dispatch("loader/loaderCancel");

      if (result) {
        this.passwords = {
          current: null,
          password: null,
          confirm: null
        };
        this.valid = null;
        this.$refs.form.reset();
        await this.$store.dispatch("notification/triggerSuccess", { detail: "Your password has been updated" });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 0.9rem;
  color: #777;
  margin-top: 10px;
}
</style>
